import React, {useContext, useEffect, useState} from "react";
import {Box, Button, Flex, Text, Image} from "rebass";
import { Form, Formik } from "formik";
import {
  CardFooter,
  Modal,
  DateInput,
  RadioInput,
} from "../Components";
import {AuthContext, PatientsContext} from "../Contexts";
import axios from "axios";
import "./ManageHeadsetsModal.css"
import { formatDiagnostic, isShorthandPropertyAssignment } from "typescript";
import useScript from 'react-script-hook';

const fetchHeadsets = async (patientID: string) => {
  return [
    {name:"headset 1", license: "Multi-Patient License", assignment: "James (28LHA)", status: "Available"},
    {name:"headset 2", license: "No License", assignment: "", status: "Available"},
    {name:"headset 3", license: "Single-Patient License", assignment: "", status: "In Use"},
    {name:"headset 4", license: "Single-Patient License", assignment: "", status: "In Use"},
    {name:"headset 5", license: "Single-Patient License", assignment: "James (28LHA)", status: "Available"},
  ]
}

export const ManageHeadsetsModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
}> = ({ isOpen, setIsOpen }) => {
  const authContext = useContext(AuthContext);
  let uid: string = authContext.user != null ? authContext.user.user_id : "";

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [headsets, setHeadsets] = useState<any>([]);
  const [selected_headset_name, setSelectedHeadsetName] = useState<string>("");

  // get headsets on first render
  useEffect(()=>{
    fetchHeadsets(uid).then((new_headsets) => setHeadsets(new_headsets))
    // get headsets on first render

  }, [])

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} headerText="Manage Headsets">
      <div style={{overflow: "auto", height: "50vh"}}>
        <table>
          <tbody>
          <tr>
            <th>Headset</th>
            <th>Licence</th>
            <th>Assigned To</th>
            <th>Status</th>
            <th></th>
          </tr>
          {headsets.map(headset =>
            <tr key={"row_" + headset.name}>{/* @ts-ignore */}
              {Object.values(headset).map(value => <td key={value + "_" + headset}>{value}</td>)}
              <td key={"button_" + headset}>
                <Button onClick={() => {setSelectedHeadsetName(headset.name); setModalIsOpen(true)}}>
                  Manage
                </Button>
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      <Flex margin={"23px"} flexDirection={"column"}>
        <Text paddingBottom={"5px"} textAlign={"center"}>You have 2 of 3 Single-Patient Licences available</Text>
        <Text paddingBottom={"10px"} textAlign={"center"}>You have 0 of 1 Multi-Patient Licences available</Text>
        <Button onClick={() => {}}>
          Purchase New Licenses
        </Button>
      </Flex>

      <ManageHeadsetModal isOpen={modalIsOpen} setIsOpen={setModalIsOpen} selected_headset_name={selected_headset_name}/>
    </Modal>
  )
}


export const ManageHeadsetModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
  selected_headset_name: string;
}> = ({ isOpen, setIsOpen, selected_headset_name}) => {
  const authContext = useContext(AuthContext);
  let uid: string = authContext.user != null ? authContext.user.user_id : "";

  // get headsets on first render
  const [headsets, setHeadsets] = useState<any>([]);
  const [shopModalOpen, setShopModalOpen] = useState(false);

  useEffect(() => {
    fetchHeadsets(uid).then((new_headsets) => setHeadsets(new_headsets))
  }, [])


  const headset = headsets.find(element => element.name === selected_headset_name) || {}

  // @ts-ignore
  const headset_values = Object.values(headset).map(value => <td key={value}>{value}</td>)

  return (
    <>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} headerText="Manage Headset">
        <Flex margin={"0 23px 23px 23px"} flexDirection={"column"}>
          <table>
            <tbody>
            <tr>
              <th>Headset</th>
              <th>Licence</th>
              <th>Assigned To</th>
              <th>Status</th>
            </tr>
            <tr>
              {headset_values}
            </tr>
            </tbody>
          </table>

          <Text paddingBottom={"5px"} textAlign={"center"}>You have 2 of 3 Single-Patient Licences available</Text>
          <Text paddingBottom={"10px"} textAlign={"center"}>You have 0 of 1 Multi-Patient Licences available</Text>

          <Flex flexDirection={"row"}>
            <Button onClick={() => {}} variant='primary' margin={2}>
              Assign Single-Patient licenses
            </Button>
            <Button onClick={() => {}} variant='disabled' margin={2}>
              Assign Single-Patient licenses
            </Button>
          </Flex>

          <Button onClick={() => {
            setShopModalOpen(true);
          }}>
            Purchase New Licenses
          </Button>

        </Flex>
      </Modal>
      <ShopModal isOpen={shopModalOpen} setIsOpen={setShopModalOpen} />
    </>
  );
};

export const ShopModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
}> = ({ isOpen, setIsOpen }) => {
  const authContext = useContext(AuthContext);
  let uid: string = authContext.user != null ? authContext.user.user_id : "";

  const [loading, error] = useScript({
    src: '//cdn.foxycart.com/vividvision/loader.js',
    checkForExisting: true,
    onload: () => main(),
  });

  const [shopData, setShopData] : any = useState<{}>({test: ""});

  const main = () => {
    fetchCart();
    fetchShopData();
  };

  const fetchShopData = async () => {
    const result = await axios.post<any>("/vue_api/get_shop_items", {

    });
    setShopData(result.data);
  };

  // TODO fetchCart isn't doing anything, we should use it or remove it
  const fetchCart = async () => {
    // @ts-ignore
    const FC = window.FC;
  };

  useEffect(() => {
       fetchCart();
       fetchShopData();
  }, []);

  if (loading) return <h3>Loading FoxyCart API...</h3>;
  if (error) return <h3>Failed to FoxyCart API: {error.message}</h3>;

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} headerText="Purchase Licenses">
      <Flex  flexDirection={"column"} margin={"0 23px 0px 23px"}>
        {shopData.items && shopData.items.map((item) => (
          <ShopItem
            key={item.form.code.name + "-item"}
            shopForm={shopData.form}
            shopItem={item}
          />
        ))}
      </Flex>
    </Modal>
  );
};
//https://'+storedomain+'/cart?'+fcc.session_get()+'&output=json&callback=?
export const ShopItem: React.FC<{
  shopForm: any;
  shopItem: any;
}> = ({ shopForm, shopItem }) => {

  return (
    <Box mb={[20, 10]}>
      <Flex flexDirection={"column"} justifyContent="center" alignItems="center" flexGrow={1}>
        {/* <input type="int" name={ "q-" + shopItem.code.name} value={0}></input> */}
        <Text
          fontSize={[ 3, 4 ]}
          color="primary"
          fontWeight="bold"
          textAlign="center"
          sx={{
            width: "100%",
            m: [1,2],
          }}>
          { shopItem.name }
        </Text>

        <Flex flexDirection={"row"} justifyContent="normal" alignItems="flex-start" my={2}>

          <Image
            src={shopItem.image}
            alt={shopItem.name}
            sx={{
              width: [175, 225],
              borderRadius: [5]
            }}
          />
          <Box width={[275, 375]} px={1}>
            <Text
              fontSize={[ 1, 2 ]}
              color='text'
              sx={{
                width: "100%",
                m: [0]
              }}>
              { shopItem.description }
            </Text>
            <Text
              fontSize={[ 0, 1 ]}
              color='text'
              sx={{
                width: "100%",
                m: [0],
                mt: [10]
              }}>
              { shopItem.tip }
            </Text>
          </Box>
        </Flex>
        <form action={shopForm.action} style={{width: "100%"}}>
          {shopItem.form && Object.entries(shopItem.form).map(([k, i]) => (
            <input key={ shopItem.form[k].code + '-' +  shopItem.form[k].value} type="hidden" name={shopItem.form[k].name} value={shopItem.form[k].value} />
          ))}
          {/* <input type="hidden" name={shopItem.name.name} value={shopItem.name.value} />
                            <input type="hidden" name={shopItem.image.name} value={shopItem.image.value} />
                            <input type="hidden" name={shopItem.code.name} value={shopItem.code.value} />
                            <input type="hidden" name={shopItem.price.name} value={shopItem.price.value} />
                            <input type="hidden" name={shopItem.category.name} value={shopItem.category.value} />
                            <input type="hidden" name={shopItem.customer_email.name} value={shopItem.customer_email.value} />
                            <input type="hidden" name={shopItem['h:purchase_order'].name} value={shopItem['h:purchase_order'].value} />
                            <input type="hidden" name={shopItem['h:doctor_id'].name} value={shopItem['h:doctor_id'].value} />
                            <input type="hidden" name={shopItem['h:crm_name'].name} value={shopItem['h:crm_name'].value} /> */}

          <Button type="submit" sx={{width: "100%"}}>{shopForm.button_text + " for $" + shopItem.price + " every 3 months"}</Button>
        </form>
      </Flex>
    </Box>
  );
};
